import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
  loading: false,
  error: null,
  orderSetting: null,
};
const settingSlice = createSlice({
  name: 'setting',
  initialState,

  reducers: {
    storeTimeSlotRequested(state, action: PayloadAction<{}>) {
      state.loading = true;
      state.error = null;
    },
    storeTimeSlotSuccess(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = null;
      state.timeSlot = action.payload;
    },
    storeTimeSlotFail(state, action: PayloadAction<{}>) {
      state.loading = false;
      state.error = action.payload;
    },
    loadOrderSettingRequested(state, action: PayloadAction<any>) {
      state.orderSettingLoading = true;
      state.error = null;
    },
    loadOrderSettingSuccess(state, action: PayloadAction<any>) {
      state.orderSettingLoading = false;
      state.error = null;
      state.orderSetting = action.payload?.result;
    },
    loadOrderSettingFail(state, action: PayloadAction<any>) {
      state.orderSettingLoading = false;
      state.error = action.payload;
    },
  },
});
export const {
  storeTimeSlotRequested,
  storeTimeSlotSuccess,
  storeTimeSlotFail,
  loadOrderSettingRequested,
  loadOrderSettingSuccess,
  loadOrderSettingFail,
} = settingSlice.actions;

export default settingSlice.reducer;
